<editor
  [init]="{ plugins: 'lists link image table code help wordcount', language: 'fr_FR' }"
  [apiKey]="tinyMceKey"
  class="my-4"
  (onFocusOut)="onEditorChange()"
  [(ngModel)]="fullText"
></editor>